import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ColourScheme, FontOptions } from "../../types";

interface UIPreferencesState {
  theme: ColourScheme;
  font: FontOptions;
}

// Initialize from localStorage or defaults
const getInitialTheme = (): ColourScheme => {
  const savedTheme = localStorage.getItem("playerTheme");
  return savedTheme ? parseInt(savedTheme) : ColourScheme.CLASSIC;
};

const getInitialFont = (): FontOptions => {
  const savedAccessibility = localStorage.getItem("playerAccessibility");
  return savedAccessibility ? parseInt(savedAccessibility) : FontOptions.DEFAULT;
};

const initialState: UIPreferencesState = {
  theme: getInitialTheme(),
  font: getInitialFont(),
};

const uiPreferencesSlice = createSlice({
  name: "uiPreferences",
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<ColourScheme>) => {
      state.theme = action.payload;
      localStorage.setItem("playerTheme", action.payload.toString());
    },
    setFont: (state, action: PayloadAction<FontOptions>) => {
      state.font = action.payload;
      localStorage.setItem("playerAccessibility", action.payload.toString());
    },
  },
});

export const { setTheme, setFont } = uiPreferencesSlice.actions;
export const uiPreferencesReducer = uiPreferencesSlice.reducer;
